import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { formatMoney } from '../../../util/currency';
import { types as sdkTypes } from '../../../util/sdkLoader';

import css from './TransportationPanel.module.css';

const { Money } = sdkTypes;

const TransportationPanel = ({
  withTransportation,
  formApi,
  values,
  chargeAmount,
  freeRange,
  isFreeTransport,
  isPricing,
  intl,
}) => {

  const transportationOptions = withTransportation ? [
    {
      label: <FormattedMessage id="BookingDatesForm.deliveryPickedUp" />,
      id: "deliveryPickedUp"
    },
    {
      label: <FormattedMessage id="BookingDatesForm.delivery" />,
      id: "delivery"
    },
    {
      label: <FormattedMessage id="BookingDatesForm.pickedUp" />,
      id: "pickedUp"
    },
    {
      label: <FormattedMessage id="BookingDatesForm.selfArranged" />,
      id: "selfArranged"
    },
  ] : [
    {
      label: <FormattedMessage id="BookingDatesForm.selfArranged" />,
      id: "selfArranged"
    },
  ];

  const handleSelectOption = (id) => {
    const value = values.transportation === id ? undefined : id;
    formApi.change("transportation", value);
  }

  return (
    <div className={css.root}>
      <h2 className={css.title}>
        <FormattedMessage id="BookingDatesForm.transportationHeadline" />
      </h2>
      <p className={css.description}>
        <FormattedMessage id="BookingDatesForm.transportationDescription" />
      </p>

      <div>
        {transportationOptions.map(({label, id}, index) => {
          const clsSelected = classNames(css.transportationOption, {
            [css.selected]: id === values.transportation,
          })

          return (
            <div key={index} className={clsSelected} onClick={() => handleSelectOption(id)}>
              <div className={css.circle} />
              <div>
                <span className={css.transportationLabel}>{label}</span>
                <span className={css.transportationValue}>
                  {withTransportation && isPricing && id !== "selfArranged" ? (
                    <FormattedMessage
                      id="BookingDatesForm.transportationPrice"
                      values={{
                        price: formatMoney(intl, new Money(chargeAmount.amount, chargeAmount.currency)),
                        freeRangeText: isFreeTransport
                          ? <FormattedMessage id="BookingDatesForm.freeRangeText" values={{ freeRange }} />
                          : "",
                      }}
                    />
                  ) : withTransportation && id !== "selfArranged" ? (
                    <FormattedMessage id="BookingDatesForm.rfq" />
                  ) : (
                    <FormattedMessage id="BookingDatesForm.noCost" />
                  )}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TransportationPanel;
